import {ValidationType} from './ValidationType'

export const PropertyOffersValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  PropertyID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  ContactID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  OfferDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  Amount: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  Notes: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Status: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  SolicitorID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  MortgageBrokerID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  MortgageProviderID: {
    validationType: ValidationType.Contact,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  MortgageFormSubmitted: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  MortgageValuation: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  MortgageAmount: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  MortgageInterestRate: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  MortgageOfferReceived: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  LocalAuthoritySearchSubmitted: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  LocalAuthoritySearchReceived: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  DraftContractsIssued: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ContractsSignedByVendor: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ContractsSignedByPurchaser: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ExchangedContracts: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ExchangeDepositPaid: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  CompletionDate: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  CompletionDateStatus: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  UpdatedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  StatusDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  ClientLoginUpdated: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PropertyChainID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  InvoiceID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  }
};
